import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SvgIconComponent } from 'angular-svg-icon';
import { NzGridModule } from 'ng-zorro-antd/grid';

@Component({
  selector: 'app-auth-layout',
  standalone: true,
  imports: [RouterOutlet, CommonModule, NzGridModule, NgOptimizedImage, SvgIconComponent],
  templateUrl: './auth-layout.component.html',
  styleUrl: './auth-layout.component.less',
})
export class AuthLayoutComponent {
  currentYear = new Date().getFullYear();
}
